<div class="stepper-container">
  <div class="steps-wrapper">
    <ng-container *ngFor="let step of steps; let i = index; let last = last">
      <div class="step-item">
        <span [ngClass]="getIconClasses(i)" [attr.aria-label]="step.label"></span>
      </div>
      
      <div *ngIf="!last" 
           class="step-line"
           [ngClass]="{ 'active-line': lineIsActive(i) }">
      </div>
    </ng-container>
  </div>

  <div class="step-label-container">
    <span *ngIf="totalSteps > 0">
      {{ currentStepNumber }}/{{ totalSteps }} - {{ currentStepLabel }}
    </span>
  </div>
</div>